import { Reducer } from "redux"
import { Display } from "../../core/types/types"
import { add, remove } from "../../core/helpers/immutability-helpers"

export interface MenuFlyoutState {
  display: Display
  direction: HTMLSdxMenuFlyoutElement["direction"]
  toggle: () => Promise<void>
  arrowEls: HTMLElement[]
  isUserInteractionInProgress: boolean
  contentEl?: HTMLSdxMenuFlyoutListElement | HTMLSdxMenuFlyoutCtaElement
  toggleEl?: HTMLSdxMenuFlyoutToggleElement
}

export type MenuFlyoutActions =
  | {
      type: "ADD_ARROW_EL"
      arrowEl: HTMLElement
    }
  | {
      type: "REMOVE_ARROW_EL"
      arrowEl: HTMLElement
    }

export const menuFlyoutReducer: Reducer<MenuFlyoutState, MenuFlyoutActions> = (
  state = {} as MenuFlyoutState,
  action,
): MenuFlyoutState => {
  switch (action.type) {
    case "ADD_ARROW_EL":
      return {
        ...state,
        arrowEls: add(state.arrowEls, action.arrowEl),
      }

    case "REMOVE_ARROW_EL":
      return {
        ...state,
        arrowEls: remove(state.arrowEls, action.arrowEl),
      }

    default:
      return state
  }
}

export function getInitialState(): MenuFlyoutState {
  return {
    display: "closed",
    direction: "bottom-right",
    toggle: () => Promise.resolve(),
    contentEl: undefined,
    isUserInteractionInProgress: false,
    toggleEl: undefined,
    arrowEls: [],
  }
}
